import { CLIENT } from './config'
import { CURRENCIES_URL } from './endpoints'

export const fetchCurrencies = async (): Promise<ICurrency[]> =>
  (await CLIENT.get(CURRENCIES_URL)).data.currencies
